<template>
  <div>
    <h2>Заказ #{{ id }}</h2>
    <list
      :itemLink="itemLink"
      :columns="columns"
      :disable_add="true"
      :params="params"
          :searchDisable="true"
    />
  </div>
</template>

<script>
import List from "../../List";

/**Меняю добавление модалку */

export default {
  name: "groups",
  components: {
    /**Меняю добавление модалку */
    List,
  },
  props: ["id"],
  created() {
    this.params.id = this.id;
  },
  data() {
    return {
      loading: true,
      loadingSearch: false,
      searcher: null,
      search: "",
      params:{
        id:null
      },
      /**Меняю ссылки на модель */
      itemLink: "admin/orders/state/list",
      /**Табличные филды */
      checked: [],
      columns: [
        {
          key: "user",
          title: "Администратора",
          checkbox: false,
          control: false,
          align: "left",
        },
        {
          key: "comment",
          title: "Действие",
          checkbox: false,
          control: false,
          align: "left",
        },
        {
          key: "created_at",
          title: "Выполнено",
          checkbox: false,
          control: false,
          align: "left",
        },
      ],
      items: {
        last_page: 0,
        current_page: 1,
        total: 0,
        data: [],
      },
    };
  },

};
</script>
<style>
</style>
